import React from "react"
import styled from "styled-components"
import { Table as AntTable } from "antd"
import { useUpdateHeaderTitle, usePermission } from "../hooks"
import { ExtraButtons } from "../components/extra-buttons"
import { Header } from "../components/layout/header"
import { VisibilityProvider } from "../components/visibility-provider"
import { getColumns } from "../pages-lib/additional-info/table-columns"
import { useGetData, useManageItems } from "../pages-lib/additional-info/model"
import { EditDrawer } from "../pages-lib/additional-info/edit-drawer"

export default function AdditionalInfo() {
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  const headerTitle = useUpdateHeaderTitle({
    items: [],
    defaultTitle: "0 разделов",
    arrType: ["раздел", "раздела", "разделов"],
  })

  const {
    dataItems,
    pagination,
    isLoading,
    handleTableChange,
    refetch: getItems,
  } = useGetData()

  const { hasPermission } = usePermission()

  const {
    editData,
    onSaveEdit,
    onCreate,
    resetData,
    onDelete,
    onEditItem,
  } = useManageItems(dataItems, getItems, onSuccessEdit, onSuccessCreate)

  function onSuccessEdit() {
    setEditDrawerState((prev) => !prev)
  }

  function onSuccessCreate() {
    setCreateDrawerState((prev) => !prev)
  }

  const columns = getColumns(
    hasPermission("additional-info.edit") ? onEditItem : null,
    hasPermission("additional-info.delete") ? onDelete : null
  )

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={
              hasPermission("additional-info.create")
                ? () => setCreateDrawerState(true)
                : undefined
            }
            titles={{ onCreate: "Добавить раздел" }}
          />
        }
      />

      <StyledTable
        dataSource={dataItems}
        columns={columns}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={pagination}
      />

      {hasPermission("additional-info.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            title={"Создание раздела"}
            onSave={onCreate}
            onClose={() => setCreateDrawerState(!createDrawerState)}
            initialValues={false}
          />
        </VisibilityProvider>
      )}

      {hasPermission("additional-info.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            title={"Редактирование раздела"}
            onSave={onSaveEdit}
            onClose={() => {
              setEditDrawerState(!editDrawerState)
              resetData()
            }}
            initialValues={editData}
          />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
